import { useEffect, useMemo, useState } from 'react'
import { useAppSelector } from '../../../../stateManagement/hooks/redux'
import { buildAdditionalMapFilteredLayer } from '../../../../widgets/map/mapFeatures/utils/buildAdditionalMapFilteredLayer'
import { useRankingThresholds } from './useRankingThresholds'

export function useRepairPlanLayers(
    hasRepairPlan: boolean,
    menuItem: any,
    mergedMapFilters: any,
    mapFiltersExpressions: any,
    currentConfig: any,
    thresholdsFilter: string | undefined
) {
    const { mapRankingIsEnabled } = useAppSelector(state => state.contentHeader)
    
    const thresholdsEnabled = useMemo(() => mapRankingIsEnabled && Boolean(thresholdsFilter), [mapRankingIsEnabled, thresholdsFilter])
    const { lowT, highT } = useRankingThresholds({ filter: thresholdsFilter, enabled: thresholdsEnabled })

    const wmsEnv = useMemo(() => {
        return mapRankingIsEnabled && lowT != null && highT != null
            ? `lowT:${lowT};highT:${highT}`
            : undefined
    }, [mapRankingIsEnabled, lowT, highT])

    const [additionalLayers, setAdditionalLayers] = useState<any>([])

    useEffect(() => {
        if (!hasRepairPlan) {
            setAdditionalLayers([])
            return
        }
        const layer = buildAdditionalMapFilteredLayer(
            menuItem,
            mergedMapFilters,
            mapFiltersExpressions,
            currentConfig,
            wmsEnv
        )
        setAdditionalLayers(layer ? [layer] : [])
    }, [hasRepairPlan, menuItem, mergedMapFilters, mapFiltersExpressions, currentConfig, wmsEnv])

    return additionalLayers
}

